import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getGlassgowCommaScoreSelector } from '../selectors'
import { IGlassgowCommaScoreState } from '../store/glassgowCommaScore.types'
import { setGlassgowCommaScore } from '../store/glassgowCommaScore.actions'
import { GlassgowCommaScoreConstants } from '../store/glassgowCommaScore.constants'

export function* calculateGlassgowCommaScore() {
  try {
    const glassgowCommaScoreData: IGlassgowCommaScoreState = yield select(getGlassgowCommaScoreSelector)
    const { gcsEye, gcsMotor, gcsVerbal } = glassgowCommaScoreData
    if (gcsEye?.id && gcsMotor?.id && gcsVerbal?.id) {
      const totalSore = gcsEye.id + gcsMotor.id + gcsVerbal.id
      yield put(setGlassgowCommaScore(totalSore))
    } else {
      yield put(setGlassgowCommaScore(null))
    }
  } catch (e) {
    yield put(throwPcrException(`calculateGlassgowCommaScore() error: ${e}`))
  }
}

export function* calculateGlassgowCommaScoreSaga() {
  yield takeLatest(
    [
      GlassgowCommaScoreConstants.SET_EYE_RESPONSE,
      GlassgowCommaScoreConstants.SET_VERBAL_RESPONSE,
      GlassgowCommaScoreConstants.SET_MOTOR_RESPONSE,
      GlassgowCommaScoreConstants.SET_GLASSGOW_COMMA_SCORE_DATA,
    ],
    calculateGlassgowCommaScore
  )
}
